var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"upline":"","title":_vm.$t('account_patient_customer.title'),"subtitle":_vm.$t('account_patient_customer.subtitle'),"bgImage":false}},[_c('PatientCustomerDataForm',{staticClass:"mb-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }